<template>
<svg
  xmlns="http://www.w3.org/2000/svg"
  id="Ebene_1"
  data-name="Ebene 1"
  viewBox="0 0 534.47 804"
  @click="onLogoClick"
>
  <path
    d="M33.47 729.27C24.69 590.61 3.61 93.5 3.61 93.5l423.43 55s18.04 607.5 19.43 631.13c-25.89-23-46.27-40.47-72.16-63.45a3.61 3.61 0 0 0-2.51-.91c-152.77 4.66-185.55 9.33-338.33 14z"
    id="path8"
    stroke="#16417c"
    stroke-linejoin="round"
    stroke-width="7.23"
    fill="#fff"
  />
  <path class="cls-2" id="rect10" d="M54.47 332h315v35h-315z" />
  <path class="cls-2" id="rect12" d="M54.47 367h151v35h-151z" />
  <path class="cls-2" id="rect14" d="M54.47 402h291v35h-291z" />
  <text
    transform="translate(56.29 183.34)"
    id="text76"
    font-family="Helvetica-Bold,Helvetica"
    font-size="28"
    fill="#c8d523"
  >
    <tspan id="tspan20" font-weight="700">
      GANZTÄGIGEN
      <tspan x="0" y="35" id="tspan16">BÜRGER-WORKSHOP</tspan>
    </tspan>
    <tspan class="cls-6" id="tspan40">
      <tspan x="0" y="70" id="tspan22">IN DER</tspan>
      <tspan class="cls-8" x="0" y="105" id="tspan32">ZENTRALWERKSTATT</tspan>
      <tspan class="cls-8" x="0" y="140" id="tspan32">OSTENSTR. 5</tspan>
    </tspan>
    <tspan
      style="font-weight: normal; font-size: 28px"
      id="tspan64"
      font-family="Helvetica,Helvetica"
      fill="#16417c"
    >
      <tspan x="0" y="175" id="tspan42">MIT FACHVORTRÄGEN</tspan>
      <tspan x="0" y="210" id="tspan56">DIALOGEN</tspan>
      <tspan x="0" y="245" id="tspan58">MITMACHSTATIONEN</tspan>
    </tspan>
    <tspan class="cls-6" id="tspan68">
      <tspan x="0" y="315" id="tspan66">SEIEN SIE DABEI!</tspan>
    </tspan>
    <tspan
      id="tspan74"
      font-size="100"
      fill="#16417c"
      font-weight="700"
      style="font-weight: bold; font-size: 100px"
    >
      <tspan x="0" y="423" id="tspan70">27/07/</tspan>
      <tspan x="0" y="513" id="tspan72">2019</tspan>
    </tspan>
  </text>
  <circle cx="434.47" cy="100" r="100" id="circle78" fill="#16417c" />
  <circle
    cx="434.47"
    cy="100"
    r="90"
    id="circle80"
    fill="none"
    stroke="#fff"
    stroke-miterlimit="10"
    stroke-width="5"
  />
  <text v-if="daysLeft <= 0" class="cls-14" transform="translate(407.04 53.8) rotate(21.97)">
    EIN
    <tspan x="0" y="35.15">LAD</tspan>
    <tspan x="0" y="71.3">UNG</tspan>
    <tspan class="cls-15">
      <tspan x="5.02" y="95.59">ZUM</tspan>
    </tspan>
  </text>
  <foreignObject v-if="daysLeft > 0" class="node" x="395" y="25" width="100%" height="300">
    <body xmlns="http://www.w3.org/1999/xhtml">
      <div style="display: flex; justify-content: center; width: 80px; height: 80px;">
        <span style="color: white; font-size: 80px;">{{daysLeft}}</span>
      </div>
    </body>
  </foreignObject>

  <text
    v-if="daysLeft > 0"
    transform="translate(386.12 95.88)"
    id="text92"
    font-size="80.1"
    font-weight="700"
    font-family="Helvetica-Bold,Helvetica"
    fill="#fff"
  >
    <tspan id="tspan86" font-size="32.84">
      <tspan style="font-size: 33px" x="6" y="37.92" id="tspan82" letter-spacing="-.07em">TAGE</tspan>
    </tspan>
    <tspan style="font-size: 20px" id="tspan90" font-size="21.63">
      <tspan x="6" y="61.95" id="tspan88">BIS ZUM</tspan>
    </tspan>
  </text>
</svg>
</template>

<script>
export default {
  props: ["daysLeft"],
  methods: {
    onLogoClick() {
      this.$router.push("/aktuelles");
    }
  }
};
</script>

<style>
#Ebene_1 {
  cursor: pointer;
  height: 100%;
  width: 100%;
  font-size: 30px;
  font-weight: bold;
}
.cls-2 {
  fill: #c8d523;
}
.cls-6,
.cls-14 {
  font-weight: 700;
}
.cls-5 {
  letter-spacing: -0.02em;
}
.cls-6 {
  fill: #16417c;
}
.cls-8 {
  letter-spacing: -0.07em;
}
.cls-9 {
  letter-spacing: -0.05em;
}
.cls-1,
.cls-14 {
  fill: #fff;
}
.cls-1 {
  stroke: #16417c;
  stroke-linejoin: round;
  stroke-width: 7.23px;
}
.cls-2,
.cls-3 {
  fill: #c8d523;
}
.cls-3 {
  font-size: 28px;
}
.cls-14,
.cls-3 {
  font-family: Helvetica-Bold, Helvetica;
}
.cls-11,
.cls-14,
.cls-4,
.cls-6 {
  font-weight: 700;
}
.cls-5 {
  letter-spacing: -0.02em;
}
.cls-10,
.cls-11,
.cls-12,
.cls-6 {
  fill: #16417c;
}
.cls-7 {
  letter-spacing: -0.04em;
}
.cls-8 {
  letter-spacing: -0.07em;
}
.cls-9 {
  letter-spacing: -0.05em;
}
.cls-10 {
  font-family: Helvetica, Helvetica;
}
.cls-11 {
  font-size: 100px;
}
.cls-13 {
  fill: none;
  stroke: #fff;
  stroke-miterlimit: 10;
  stroke-width: 5px;
}
.cls-14 {
  font-size: 45.34px;
}
.cls-15 {
  font-size: 27.1px;
}
</style>
